import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/InitialCustomerPageLoad'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class InitialCustomerPageLoadStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "InitialCustomerPageLoadStore",
			variables: false,
		})
	}
}

export async function load_InitialCustomerPageLoad(params) {
  await initClient()

	const store = new InitialCustomerPageLoadStore()

	await store.fetch(params)

	return {
		InitialCustomerPageLoad: store,
	}
}
